import { useTripsStore } from '../../stores/useTripsStore';

export function useTrip(tripUid) {
    
    return useTripsStore(
        state =>
            tripUid
                ? state.tripsMap.get(tripUid)
                : undefined
    );
}